export enum TrackingEvent {
    VIEWED_PAGE_DAHSBOARD = 'Viewed the Dashboard',
    VIEWED_PAGE_DATA = 'Viewed the Data page',
    VIEWED_PAGE_REPORTS = 'Viewed the Reports page',
    VIEWED_PAGE_LOGIN = 'Viewed the Login page',
    VIEWED_PAGE_PATHS = 'Viewed the Paths page',
    VIEWED_PAGE_VISITS = 'Viewed the Visits page',
    VIEWED_PAGE_SETTINGS_ACCOUNT = 'Viewed the Account page',
    VIEWED_PAGE_SETTINGS_DEVICES = 'Viewed the Devices page',
    VIEWED_PAGE_SETTINGS_PRIVACY_POLICY = 'Viewed the Privacy Policy page',
    VIEWED_PAGE_SETTINGS_SUPPORT = 'Viewed the Support page',
    VIEWED_PAGE_SETTINGS_TERMS_AND_CONDITIONS = 'Viewed the Terms And Conditions page',
    LOGGED_IN = 'Logged in to the portal',
    LOGGED_OUT = 'Logged out of the portal',
    GROWTH_REPORT_DOWNLOADED = 'Growth report downloaded',
    SECA_REPORT_DOWNLOADED = 'Seca report downloaded',
    OWP_TENNIS_REPORT_DOWNLOADED = 'OWP tennis report downloaded',
    OWP_GOLF_REPORT_DOWNLOADED = 'OWP golf report downloaded',
    AEROBIC_ENDURANCE_REPORT_DOWNLOADED = 'Aerobic Endurance report downloaded',
    MOVEMENT_ANALYSIS_REPORT_DOWNLOADED = 'Movement Analysis report downloaded',
    THERMAL_BODY_MAPPING_REPORT_DOWNLOADED = 'Thermal Body Mapping report downloaded',
    MOVE_ACCORDION_OPENED = 'Move accordion opened',
    NOURISH_ACCORDION_OPENED = 'Nourish accordion opened',
    REST_ACCORDION_OPENED = 'Rest accordion opened',
    MOVE_ACCORDION_CLOSED = 'Move accordion closed',
    NOURISH_ACCORDION_CLOSED = 'Nourish accordion closed',
    REST_ACCORDION_CLOSED = 'Rest accordion closed',
    VIEWED_SUBDOMAIN = 'Viewed subdomain',
    DEEP_DIVE_DIALOG_OPENED = 'Opened the deep dive dialog',
    DEEP_DIVE_DIALOG_CLOSED = 'Closed the deep dive dialog',
    DEFAULT_VALUE_DIALOG_OPENED = 'Opened the default value dialog',
    DEFAULT_VALUE_DIALOG_CLOSED = 'Closed the default value dialog',
    OPENED_INFO_POPOVER = 'Opened score info popover',
    CLOSED_INFO_POPOVER = 'Closed score info popover',
    VIEWED_DATA_TAB = 'Viewed data tab',
    REFRESH_MY_DATA_CLICKED = 'Clicked to Refresh my data',
    DEVICE_SYNC_FINISHED = 'Device synchronization finished',
    DATE_FILTER_ACTIVATED = 'Activated date filter',
    DEEP_DIVE_DATE_FILTER_ACTIVATED = 'Changed deep dive bar chart filter',
    SAVE_ACCOUNT_CLICKED = 'Save account clicked',
    FIRST_NAME_CHANGED = 'First name edited',
    LAST_NAME_CHANGED = 'Last name edited',
    GENDER_CHANGED = 'Gender edited',
    PREFERRED_NAME_CHANGED = 'Preferred name edited',
    BIRTHDAY_CHANGED = 'Birthday edited',
    EMAIL_ADDRESS_CHANGED = 'Email address edited',
    DEVICE_DISCONNECT_BUTTON_CLICKED = 'Clicked the disconnect button',
    DEVICE_CONNECT_BUTTON_CLICKED = 'Clicked the connect button',
    OPT_IN_DIALOG_OPENED = 'Opened the Opt-In dialog',
    OPT_IN_DIALOG_CLOSED = 'Closed the Opt-In dialog',
    OPT_IN_LATER_CLICKED = 'Opt-in later button clicked',
    OPT_IN_TRY_AGAIN_CLICKED = 'Opt-In try again button clicked',
    OPT_IN_DEVICE_SELECTED = 'Opt-In device selected',
    OPT_IN_FINISH_CLICKED = 'Opt-In Finish button clicked',
    SUBMITTED_SUPPORT_MESSAGE = 'Support message submitted',
    CONNECT_YOUR_WHOOP_CLICKED = 'Connect your Whoop button clicked',
    PAQ_CLICKED = 'Pre-Arrival Questionnaire button clicked',
    ITINERARY_CLICKED = 'Your Itinerary button clicked',
    PACKING_LIST_CLICKED = 'Your Packing list button clicked',
    ACTIVITY_CALENDAR_CLICKED = 'Activity calendar button clicked',
    EXPERIENCES_MENU_CLICKED = 'Experiences menu button clicked',
    PROPERTY_MAP_CLICKED = 'Property Map button clicked',
    COVID_POLICY_CLICKED = 'Covid policy button clicked',
    VIEWED_EXPERIENCES_TAB = 'Viewed experiences tab',
}
